module.exports = __webpack_public_path__ + "expand_more_white-v1-250aa05f.svg";